// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE.name];
const storageApi = {
  getFileNames(campaignId, payload) {
    const folderParam = payload.folder ? `&folder=${payload.folder}` : '';
    return client.get(`/storage/campaigns/${campaignId}/files?bucket=${payload.bucket}${folderParam}`)
      .then((response) => response.data);
  },
  getFile(campaignId, payload) {
    const folderParam = payload.folder ? `&folder=${payload.folder}` : '';
    return client.get(`/storage/campaigns/${campaignId}/file?bucket=${payload.bucket}&fileName=${payload.fileName}${folderParam}`)
      .then((response) => response.data);
  },
  downloadAnArchive(campaignId, payload) {
    const folderParam = payload.folder ? `&folder=${payload.folder}` : '';
    const config = { responseType: 'arraybuffer' };
    return client.get(`/storage/campaigns/${campaignId}/archive?bucket=${payload.bucket}${folderParam}`, config)
      .then((response) => response.data);
  },
  uploadFile(campaignId, payload) {
    const folderParam = payload.folder ? `&folder=${payload.folder}` : '';
    const config = {
      ...client.defaults,
      headers: {
        ...client.defaults.headers,
        'Content-Type': 'multipart/form-data',
      },
    };
    return client.post(`/storage/campaigns/${campaignId}/file?bucket=${payload.bucket}${folderParam}`, payload.formData, config)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  deleteFile(campaignId, payload) {
    const folderParam = payload.folder ? `&folder=${payload.folder}` : '';
    return client.delete(`/storage/campaigns/${campaignId}/file?bucket=${payload.bucket}&fileName=${payload.fileName}${folderParam}`)
      .then((response) => response.data);
  },
};
export default storageApi;
